var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "99px",
    viewBox: "0 0 48 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0420\u0435\u0441\u0443\u0440\u0441 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-234.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0420\\u0435\\u0441\\u0443\\u0440\\u0441-2",
    transform: "translate(234.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.71,99.19 C27.71,87.19 17.89,77.92 12.89,72.83 C-0.22,59.48 -9.59232747e-13,53.41 -9.59232747e-13,49.63 C-9.59232747e-13,45.85 0.42,38.7 12.89,26.63 C24.16,15.8 27.08,8.15 27.71,-1.8189894e-12 L27.71,99.19 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-button",
    transform: "translate(7.600000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#21CEB4",
    fillRule: "nonzero",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5825541,20.5118974 C21.0786914,17.0157601 22.9660118,15.1284398 23.2445152,14.8499363 C23.6622703,14.4321812 23.7246426,13.8172385 23.2445152,13.3371112 C22.7643878,12.8569838 22.1494451,12.919356 21.73169,13.3371112 C21.4531866,13.6156146 19.3137287,15.7550725 15.3133164,19.7554848 C14.8955612,20.17324 14.8955612,20.8505549 15.3133164,21.26831 L21.73169,27.6866836 C22.1494451,28.1044388 22.82676,28.1044388 23.2445152,27.6866836 C23.6622703,27.2689285 23.6622703,26.5916136 23.2445152,26.1738585 L17.5825541,20.5118974 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.a0b11d9a.svg";
export { ForwardRef as ReactComponent };